import { Dictinary } from "@app/shared/models";
import { ProfessionalSport } from "@app/shared/models/dict/professional-sport.model";
import { createAction, props } from "@ngrx/store";

export const loadProfessionalSportList = createAction(
  "[Directory / API] Load Professional sport List",
);
export const loadProfessionalSportListSuccess = createAction(
  "[Directory / API] Load Professional sport List Success",
  props<{ ProfessionalSportList: ProfessionalSport[] }>(),
);
export const loadProfessionalSportListFailure = createAction(
  "[Directory / API] Load Professional sport List Failure",
  props<{ error: Dictinary[] }>(),
);
